export default __webpack_public_path__ + "static/media/1711.3f3749a4.png";